import { NovaPoshtaType } from "src/modules/AddressManagement/components/NovaPoshtaTab/useNovaPoshtaTabProps";
import { DeliveryType } from "src/redux/apiTypes";
import { LocalizeFunc } from "src/services/localization/types";

export interface Params {
  deliveryType: DeliveryType;
  isNewFinScheme: boolean;
  localize: LocalizeFunc;
  novaPoshtaType?: NovaPoshtaType;
}

export const getNPShippingText = ({ deliveryType, isNewFinScheme, localize, novaPoshtaType }: Params): null | string => {
  const isNotNpDelivery = !deliveryType?.includes('nova_poshta');
  if(isNotNpDelivery) {
    return null;
  }

  const isNpFresh = deliveryType === 'nova_poshta_fresh';
  const isPostomat = novaPoshtaType === 'postomat';

  if (isPostomat) {
    return localize('nova_poshta_postomat_non_shipped_products');
  }

  if (isNewFinScheme) {
    return isNpFresh ? null : localize('nova_poshta_nfs_non_shipped_products');
  } else {
    return localize(isNpFresh ? 'nova_poshta_fresh_non_shipped_products' : 'np.non.shipped.products');
  }
};
